/**
 * EventEmitterをVueのプラグインとして提供する
 *
 * @example
 * this.$eventEmitter.emit('create-user', 'Oliver Caldwell', 'okok')
 *
 * function sendCreateRequest(name, name2) {
 *   console.log(name) // = > 'Oliver Caldwell'
 *   console.log(name2) // = > 'okok'
 * }
 *
 * this.$eventEmitter.on('create-user', sendCreateRequest)
 * this.$eventEmitter.removeListener('create-user', sendCreateRequest)
 */

import EventEmitter from 'eventemitter3'

const eventEmitter = new EventEmitter()

export default {
  install(Vue) {
    Vue.eventEmitter = eventEmitter

    Object.defineProperties(Vue.prototype, {
      $eventEmitter: {
        get() {
          return eventEmitter
        }
      }
    })
  }
}
